module.exports = __webpack_public_path__ + "static/pagespeed-insights-39065741d2904cc5270fe0757bd1593f.png";